import { render, staticRenderFns } from "./RollerView.vue?vue&type=template&id=6d10e326&"
import script from "./RollerView.vue?vue&type=script&lang=js&"
export * from "./RollerView.vue?vue&type=script&lang=js&"
import style0 from "./RollerView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports